import { styled } from '@mui/material'

export const CardsContainer = styled('div')`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
`
